import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950">AcBuy Spreadsheet</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-sm">
              Your trusted source for discovering the best AcBuy spreadsheet products, verified sellers, and expert buying guides. Updated daily to help you shop smarter and safer.
            </p>
            <div className="flex items-center gap-3">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-background-300 transition-colors cursor-pointer">
                <i className="ri-external-link-line"></i>
              </a>
              <span className="text-xs text-foreground-500">Visit Main Site</span>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Home</Link>
                <Link to="/acbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Buying Guide</Link>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Main Website</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Browse Spreadsheet</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Top Categories</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/acbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">How It Works</Link>
                <Link to="/acbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Safety Tips</Link>
                <Link to="/acbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">FAQ</Link>
                <Link to="/acbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Comparison</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} AcBuy Spreadsheet. All rights reserved. Not affiliated with any brand mentioned.
          </p>
          <div className="flex items-center gap-5">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Privacy</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Terms</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}